import(/* webpackMode: "eager" */ "/vercel/path0/src/app/categories/kitchen/page.js");
